import { ChartContextExtractor } from "components/charts/utils/chartContextExtractor";
import { MapContextExtractor } from "components/map/utils/mapContextExtractor";
import { widgetContextExtractorRegistry } from "components/screenshot/utils/widgetContextExtractors";
import { XDAContextExtractor } from "components/vis/utils/xdaContextExtractor";

/**
 * Initialize all widget context extractors
 * This should be called once during app initialization
 */
export function initializeWidgetContextExtractors() {
  // Register chart extractors
  widgetContextExtractorRegistry.register(new ChartContextExtractor());

  // Register map extractor
  widgetContextExtractorRegistry.register(new MapContextExtractor());

  // Register XDA extractor
  widgetContextExtractorRegistry.register(new XDAContextExtractor());

  // Add more extractors as needed for other widget types like:
  // - SAM charts
  // - Multiphase charts
  // - etc.
}

// Auto-initialize when this module is imported
initializeWidgetContextExtractors();
